import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "miniDel",
  "use": "miniDel-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"miniDel\"><mask id=\"miniDel_a\" height=\"14\" maskUnits=\"userSpaceOnUse\" width=\"14\" x=\"0\" y=\"0\"><path d=\"M0 0h14v14H0z\" fill=\"#fff\" /></mask><path d=\"M10.5 9.4l-1.1 1.1L7 8.1l-2.4 2.4-1.1-1.1L5.9 7 3.5 4.6l1.1-1.1L7 5.9l2.4-2.4 1.1 1.1L8.1 7zM7 0C3.1 0 0 3.1 0 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z\" mask=\"url(#miniDel_a)\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id